import { Ability } from '@casl/ability'
import { initialAbility } from './initialAbility'

// Initialise the CASL Ability from whatever is in localStorage. This may be
// stale after a deploy that changed the permission schema; that's fine —
// `useAbilityRehydrate` refreshes it against `/auth/me` on app mount, so the
// stale snapshot is replaced silently within the first request round-trip.
const userData = JSON.parse(localStorage.getItem('userData') || 'null')
const existingAbility = userData ? userData.ability : null

export default new Ability(existingAbility || initialAbility)
